export const URL_BASE_PROD = process.env.REACT_APP_BACKEND_URL ?? 'http://localhost:8080'